module.exports = __webpack_public_path__ + "static/media/语音控制画笔.8269ebb7.png";